import React from 'react'
import md5 from 'md5'
import AvatarInitials from 'avatar-initials'
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'
import { getInitials, getDisplayName } from '../util/name_utils'

const stringToColour = (str) => {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    let colour = '#'
    for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xFF
        colour += ('00' + value.toString(16)).substr(-2)
    }
    return colour
}

const getContrastYIQ = (hexcolor) => {
    const r = parseInt(hexcolor.substr(0,2),16)
    const g = parseInt(hexcolor.substr(2,2),16)
    const b = parseInt(hexcolor.substr(4,2),16)
    const yiq = ((r*299)+(g*587)+(b*114))/1000
    return (yiq >= 128) ? 'black' : 'white'
}

export default class Avatar extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        if (this.props.emailAddress) {
            this.prepareAvatar(this.props)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.emailAddress && nextProps.emailAddress !== this.props.emailAddress) {
            this.prepareAvatar(nextProps)
        }
    }

    prepareAvatar(props) {
        const hashedEmail = md5(props.emailAddress)
        const color = stringToColour(props.emailAddress)
        const { name, emailAddress, isCounter } = props
       
        const counter = {
            'useGravatar': true,
            'initials': getInitials(getDisplayName(name, emailAddress)),
            'hash': hashedEmail,
            'fallback': 'mm',
            'initial_font_family': 'Rubik',
            'initial_weight': 50,
        }
        const notCounter = {...counter, 'initial_weight': 500, 'initial_fg': getContrastYIQ(color), 'initial_bg': color}
        
        new AvatarInitials(this.avatarImg, isCounter ? counter : notCounter)
    }

    onClick = () => {
        const { emailAddress, onClick } = this.props
        if (onClick) {
            onClick(emailAddress)
        }
    }

    render() {
        const { emailAddress, tooltipText, name } = this.props
        const tooltipTextToUse = tooltipText
            ? tooltipText
            : getDisplayName(name, emailAddress)
        return (
            this.props.showTooltip
                ?
                <OverlayTrigger placement="bottom" delayShow={300} delayHide={150}
                    overlay={<Tooltip id="tip-avatar">{tooltipTextToUse}</Tooltip>}>
                    <img className="avatar" ref={img => { this.avatarImg = img }} alt="User" onClick={this.onClick} />
                </OverlayTrigger>
                : <img className="avatar" ref={img => { this.avatarImg = img }} alt="User" onClick={this.onClick} />
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/avatar.jsx